// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__oZlmD","head":"ProcedureTableInfo_head__382bW"};